
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insertion",
      function () {
        return require("private-next-pages/insertion.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insertion"])
      });
    }
  